import { CSSProperties, memo } from 'react';
import { isObject } from 'lodash';

import {
  AttachmentImage,
  FileType,
  ImageVersion,
  Uuid,
} from '../../../models/Base';

type Attachment = {
  resource: AttachmentImage;
  fileType?: never;
  imageVersion?: ImageVersion;
};

type MediaFile = {
  resource: Uuid; // fileId
  fileType: FileType.Image | FileType.ResourceImage;
  imageVersion?: ImageVersion;
};

type SourceFile = {
  resource: { uri: string };
  fileType?: never;
  imageVersion?: never;
  style?: CSSProperties;
};

type Skeleton = {
  resource: undefined;
  fileType?: never;
  imageVersion?: ImageVersion;
};

export type JoyajoyImageFile = Attachment | MediaFile | SourceFile | Skeleton;

export type JoyajoyImageProps = JoyajoyImageFile & {
  style?: CSSProperties;
  className?: string;
};

const isUri = (file: JoyajoyImageFile): file is SourceFile => {
  return (
    file.resource !== undefined &&
    ((isObject(file.resource) && 'uri' in file.resource) ||
      typeof file.resource === 'number')
  );
};

export const JoyajoyImage = memo((props: JoyajoyImageProps) => {
  if (isUri(props)) {
    const { resource, style, className } = props;
    return <img src={resource.uri} style={style} className={className} />;
  }

  return <></>;
  // return <InnerImage {...props} />;
});
